/**
 * Process-level registry that bridges TestRelicService → TestRelicReporter.
 *
 * Both service and reporter are instantiated by WDIO in the same worker process,
 * but WDIO never connects them automatically. Using `process` as the carrier
 * ensures the registry works even when service.ts and index.ts are built as
 * separate tsup bundles (each has its own module scope, but both share `process`).
 */

import type { TestRelicService } from './service.js';

const REGISTRY_KEY = '__testrelic_appium_service__';

/**
 * The carrier, as an indexable object.
 *
 * SAFETY: `process` is deliberately the carrier so the registry survives the
 * two separate tsup bundles (see the note above), and `Process` has no index
 * signature. The single key is a module constant, never user input.
 */
function registry(): Record<string, unknown> {
  return process as unknown as Record<string, unknown>;
}

export function registerService(s: TestRelicService): void {
  registry()[REGISTRY_KEY] = s;
}

export function getServiceInstance(): TestRelicService | null {
  return (registry()[REGISTRY_KEY] as TestRelicService | undefined) ?? null;
}

export function clearServiceRegistry(): void {
  delete registry()[REGISTRY_KEY];
}
